import { Token } from '@/domain/types/Token'
import { SwapContainer } from '@/features/swap/SwapContainer'
import { Dialog, DialogContent, DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { Typography } from '@/ui/atoms/typography/Typography'

interface SwapDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
  defaultToToken?: Token
}

export function SwapDialog({ open, setOpen, defaultToToken }: SwapDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined} className="px-2">
        <DialogTitle>
          <Typography variant="span" className="ml-3 font-bold text-xl lg:text-4xl" gradient>
            Swap
          </Typography>
        </DialogTitle>

        <div className="mt-3">
          <SwapContainer
            key={defaultToToken?.address ?? 'default'}
            isModal={true}
            withHeading={false}
            token={defaultToToken}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
